import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/templates/new-bundle',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TemplateNewBundleContainer',
      './modules/templateNewBundle'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const TemplateNewBundle = require('./containers/TemplateNewBundleContainer').default
      const actions = require('./modules/templateNewBundle')
      const reducer = require('./modules/templateNewBundle').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'templateNewBundle', reducer: reducer })

      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, TemplateNewBundle)

    /* Webpack named bundle   */
    }, 'templateNew')
  }
})



// WEBPACK FOOTER //
// ./src/routes/TemplateNewBundle/index.js